<template>
  <div>
    <div class="d-flex justify-space-between py-2 px-3 rounded-t flex-wrap" style="background-color: #e9edf4;">
      <div class="d-flex align-center gap">
        <v-icon size="40px" color="darkblue" icon="mdi-folder-account"></v-icon>
        <div>
          <div class="text-h6 font-weight-bold">Commande n°{{ commande.uuid }}</div>
          <div class="text-body-1">Passée le {{ $moment(commande.timestamp).format("DD/MM/YYYY à HH:mm") }}</div>
        </div>
      </div>
      <div class="d-none d-sm-flex flex-column align-end">
        <div class="text-h5 font-weight-bold">
          {{ commande.prix_total }}€
        </div>
        <div class="text-body-1">{{ nb_participants }} Participant<span v-if="nb_participants > 1">s</span></div>
      </div>

    </div>
    <div class="rounded-b mb-3 bordered border-light_bluegrey pa-2">
      <NoticePendingPaymentRequests v-if="has_pending_payment_requests" :requests="commande.pendings_payment_requests">
      </NoticePendingPaymentRequests>

      <ActionsCardCommande :item="commande"></ActionsCardCommande>
      <CommandeInscriptionItem v-for="item in commande.list_commandes_inscriptions_coureur" :item="item" :key="item.id">
      </CommandeInscriptionItem>
    </div>
  </div>
</template>

<script>
import CommandeInscriptionItem from "./Commande_Inscription_Item.vue";
import ActionsCardCommande from "./Actions_Card_Commande.vue";
import NoticePendingPaymentRequests from "./Notice_Pending_Payment_Requests.vue";
export default {
  components: {
    ActionsCardCommande,
    CommandeInscriptionItem,
    NoticePendingPaymentRequests,
  },
  computed: {
    nb_participants() {
      return this.commande.list_commandes_inscriptions_coureur.length;
    },
    has_pending_payment_requests() {
      return this.commande?.pendings_payment_requests?.length > 0;
    },
  },
  data() {
    return {
      commande: {},
    };
  },
  props: ["item"],
  created() {
    this.commande = this.item;
  },
};
</script>

<style lang="scss" scoped></style>